<div class="h-100">
  <div class="d-flex flex-column h-100 align-items-center justify-content-center error-group">
 <h1 class="m-0 text-large">401</h1>
 <p class="m-0 text-medium">Unauthorized Access</p>
  <p class="m-0 is-note">Note: Invalid Domain Name or PartId</p>
  </div>
</div>
